import { toast } from 'react-toastify'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import API from '../../../utils/api'
import { errorToaster } from '../../../utils/helper'
import { CLINIC_ADMIN_RESET_PASSWORD_REQUEST } from '../../actions/actionTypes'
import {
  clinicAdminResetPasswordRequestFailure,
  clinicAdminResetPasswordRequestSuccess,
} from '../../actions/authActions/resetPasswordAction'

function* clinicAdminResetPasswordRequestSaga(payload: any): any {
  try {
    const response = yield API.post(`v1/auth/reset/password`, payload.payload)
    toast.success(response.data?.meta?.message)
    yield call(payload.payload.callback, response.data)
    yield put(
      clinicAdminResetPasswordRequestSuccess({
        resetPasswordData: response.data,
      })
    )
  } catch (e: any) {
    // TODO: update toast according to status code
    errorToaster(e?.meta?.message)
    yield put(
      clinicAdminResetPasswordRequestFailure({
        resetPasswordError: e?.meta?.message,
      })
    )
  }
}

function* postClinicAdminResetPasswordSaga() {
  yield takeEvery(CLINIC_ADMIN_RESET_PASSWORD_REQUEST, clinicAdminResetPasswordRequestSaga)
}

export default function* clinicAdminResetPasswordSaga() {
  yield all([postClinicAdminResetPasswordSaga()])
}
